export default "__VITE_PUBLIC_ASSET__245a83a6__"